import React from 'react';
import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {withAuthenticationRequired} from "@auth0/auth0-react";
import Layout from "./layouts/Layout";
import PermissionProvider from "./features/employee/PermissionProvider";
import LoadingBlock from "./components/loader/LoadingBlock";
import Auth0Provider from "./features/auth/Auth0Provider";
import Loader from "./components/loader/Loader";
import CategoryTable from "./features/category/CategoryTable";
import PartnerTable from "./features/partner/PartnerTable";

const ErrorNotFound = React.lazy(() => import("./components/error/ErrorNotFound"))

function App() {
    return (
        <BrowserRouter>
            <Auth0Provider>
                <Layout>
                    <PermissionProvider>
                        <React.Suspense fallback={<LoadingBlock/>}>
                            <Routes>
                                <Route index element={<PartnerTable/>}/>
                                <Route path={'/category'} element={<CategoryTable/>}/>
                                <Route path={'*'} element={<ErrorNotFound/>}/>
                            </Routes>
                        </React.Suspense>
                    </PermissionProvider>
                </Layout>
            </Auth0Provider>
        </BrowserRouter>
    );
}

export default withAuthenticationRequired(App, {
    onRedirecting: () => <Loader/>
});